import { Fragment } from 'react';
import SummaryBoxPaymentMethod from './summary-box-payment-method';

const SummaryBox = (props) => {
  const {
    summary, address, method, shipMethodItemMap,
  } = props;
  return (
    <div className="summary-box">
      <div className="ff-graphik">
        <div className="summary-header">
          <h3 className="ff-wallop c-purple fw-medium summary-header-label">
            {summary}
            {' '}
            Info
          </h3>
        </div>
        <div className="summary-body">
          <div className="summary-child summary-child-top">
            <h4
              className="c-midnight summary-label fw-medium ff-graphik-medium fs-p3"
            >
              {summary}
              {' '}
              Address
            </h4>
            <div>
              <p className="m-b-8 fs-p3 c-midnight">{`${address.streetName} ${address.additionalStreetInfo ?? ''}`}</p>
              <div className="fs-p3">
                <p className="m-b-8 c-purple">
                  <span>
                    {`
                    ${address.city}, ${address.state} 
                    ${address.postalCode} ${address.country}
                    `}
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div className="summary-child">
            <h4 className="m-b-8 c-midnight summary-label ff-graphik-medium fw-medium fs-p3">
              {summary === 'Billing' ? 'Payment' : summary}
              {' '}
              Method
            </h4>
            {summary === 'Shipping' ? (
              <div className="summary-info ff-graphik fw-normal fs-p3">
                { shipMethodItemMap &&
                Object.keys(shipMethodItemMap)?.map((shippingMethod) => (
                  <Fragment key={shippingMethod}>
                    <div className="shipping-method m-b-8 c-purple">
                      {shipMethodItemMap[shippingMethod][0].shipping}
                    </div>
                  </Fragment>
                ))}
              </div>
            ) : <SummaryBoxPaymentMethod method={method} /> }
          </div>
        </div>
      </div>
    </div>
  );
};

export default SummaryBox;
